module.exports = __webpack_public_path__ + "images/18c737cf6a6fc9d445dd8986e13327e2-ISLA-MUJERES-WHITE.png";